import { Box, Button, Typography } from '@mui/material'
import Lottie from 'lottie-react'
import React from 'react'
import NotFoundAnimation from '../../lottie/animation404.json'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'
function NotFound() {
    const navigate = useNavigate()
    return (
        <Box display={'flex'} alignItems={'center'} flexDirection={'column'} gap={1}>
            <Lottie style={{ width: '300px' }} animationData={NotFoundAnimation}></Lottie>
            <Typography>{t('error:notfound:heading')}</Typography>
            <Typography fontSize={'13px'}>{t('error:notfound:subHeading')}</Typography>
            <Button onClick={() => navigate('/')} variant='contained'>{t('registration:back')}</Button>
        </Box>
    )
}

export default NotFound